/**
 * 数据构造 API（辅助工具 → 数据构造）
 * 含：虚拟数据生成、批量参数化造数、数据脱敏、编码与加解密
 * 所有生成数据仅供测试使用，禁止用于任何真实场景
 */
import { post } from '@/utils/request'
import type {
  BatchDataResult, BatchFieldRule, CryptoRequest, CryptoResult,
  FakeDataItem, FakeDataType, MaskDataResult, MaskRuleType,
} from '@/types'

/** 虚拟数据生成（手机号/身份证/姓名/银行卡，内置校验位算法校验） */
export const generateFakeData = (data: { type: FakeDataType; count: number }) =>
  post<{ type: FakeDataType; items: FakeDataItem[] }>('/data-factory/fake', data)

/** 批量参数化造数（字段规则 → N 行 CSV/JSON） */
export const generateBatchData = (data: { fields: BatchFieldRule[]; count: number; format: 'csv' | 'json' }) =>
  post<BatchDataResult>('/data-factory/batch', data)

/** 数据脱敏（粘贴文本按内置规则脱敏） */
export const maskData = (data: { content: string; rules: MaskRuleType[] }) =>
  post<MaskDataResult>('/data-factory/mask', data)

/** 编码与加解密（Base64/URL/MD5/SHA/HMAC/AES） */
export const cryptoTransform = (data: CryptoRequest) =>
  post<CryptoResult>('/data-factory/encode', data)

/** 结果文本下载为本地文件（造数结果导出） */
export const downloadTextFile = (filename: string, content: string) => {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
